import {
  GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS,
  GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS_SUCCESS,
  API_ERROR

} from "./actionTypes"




export const getPageOperationListForValueByParams = record => ({
  type: GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS,
  payload: record
})

export const getPageOperationListForValueByParamsSuccess = record => ({
  type: GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS_SUCCESS,
  payload: record,
})



export const pageOperationError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

